/**
 * Core dataLayer push utility
 * Checks if the GTM dataLayer exists before pushing.
 * Unlike the legacy pushEvent, this does not skip localhost: the guard on
 * window.dataLayer is enough (GTM only defines it once loaded), and preprod
 * validation runs on a real host anyway.
 */
export const pushToDataLayer = (event, data = {}) => {
  if (typeof window === "undefined" || !window.dataLayer) {
    console.debug("[Analytics] dataLayer not available", event, data);
    return false;
  }

  window.dataLayer.push({
    event,
    ...data,
    timestamp: new Date().toISOString(),
  });

  console.debug("[Analytics] Event pushed:", event, data);
  return true;
};

/**
 * Clear ecommerce data before pushing a new ecommerce event
 * (GTM best practice to avoid data bleeding between events)
 */
export const clearEcommerceData = () => {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({ ecommerce: null });
  }
};
